import { isObject, cloneDeep, debounce } from 'lodash-es';
import { PROCESS_ENV_ENUM, DOMAIN_ENV_ENUM } from '@myna/utils';

import { ElLoading } from 'element-plus';

let needLoadingRequestCount = 0;
let loadingInstance: any | null = null;

function startLoading(message = '') {
  loadingInstance = ElLoading.service({
    text: message,
  });
}

function endLoading() {
  if (loadingInstance) {
    loadingInstance?.close();
  }
  loadingInstance = null;
}

function tryCloseLoading() {
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}

export function showFullScreenLoading(message = ''): void {
  if (needLoadingRequestCount === 0) {
    startLoading(message);
  }
  needLoadingRequestCount += 1;
}

export function hideFullScreenLoading(): void {
  if (needLoadingRequestCount <= 0) {
    return;
  }
  needLoadingRequestCount -= 1;
  if (needLoadingRequestCount === 0) {
    debounce(tryCloseLoading, 300)();
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isEmpty(val: any): boolean {
  return val === null || val === '' || val === undefined;
}

/* eslint-disable */
export const deepDeleteEmptyValue = (o: any) => {
  if (!isObject(o)) {
    return o;
  }
  const newVal: any = cloneDeep(o);
  for (const key in newVal) {
    if (!newVal.hasOwnProperty(key)) {
      continue;
    }
    if (isObject(newVal[key])) {
      newVal[key] = deepDeleteEmptyValue(newVal[key]);
      continue;
    }
    if (isEmpty(newVal[key])) {
      delete newVal[key];
    }
  }
  return newVal;
};

// 域名处理
export const handleRealmName = (env: PROCESS_ENV_ENUM | DOMAIN_ENV_ENUM) => {
  let developmentMainDomain = '';
  let mainDomain = '';
  // 直接使用process.env.env判断，防止生产环境传env有误
  if (env === PROCESS_ENV_ENUM.ENV || env === DOMAIN_ENV_ENUM.PROD || env === DOMAIN_ENV_ENUM.BLUE) {
    // 生产环境用
    mainDomain = 'textile-story.com';
    developmentMainDomain = 'textile-story.com';
  } else if (/uat[0-9]?/g.test(env)) {
    // uat环境用
    mainDomain = 'textile-story.com';
    developmentMainDomain = 'textile-story.com';
  } else {
    // 其他开发测试环境用yunbanfang.cn
    mainDomain = 'yunbanfang.cn';
    developmentMainDomain = 'yunbanfang.cn';
  }
  return {
    mainDomain,
    developmentMainDomain,
  };
};
